import { render } from "./Turmas.vue?vue&type=template&id=52a5f91a"
import script from "./Turmas.vue?vue&type=script&lang=js"
export * from "./Turmas.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__